<template>
  <div class="index">
     <div class="title">
        <span class="shu"></span>
        <span class="name">{{topTitle[catalog]}}</span>
        <span class="search">
          <el-input placeholder="请输入关键字" v-model="searchWord">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="searchTitle()"></i>
          </el-input>
        </span>
     </div>
    <div class="contbox">
      <ul class="newslist">
        <li class="item flex" v-for="(x,i) in tableData" :key="i" @click="jumpToDetail(x.catalog,x.id,x.outUrl)" >
          <img :src="x.homeUrl|toimg" />
          <div class="words">
            <p class="p1">{{x.title}}</p>
            <p class="p2">{{x.description}}</p>
            <p class="p3">
              <span class="time">发表时间：{{x.createTime}}</span>
              <span class="view">{{x.viewTime}}人浏览</span>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <paging :pagesData="$data.paging_data" @set_page_number="get_page_number_article"></paging>
  </div>
</template>

<script>
import mixins from '@/Mixins/mixin_3g48.js'
export default {
  mixins: [mixins],
  data() {
    return {
      topTitle: {
        briefIntroduction: '简介',
        idea: '理念',
        culture: '文化',
        team: '团队',
        routeLine: '路线',
        contactUs: '联系我们',
        news: '新闻',
        activity: '活动',
        knowledge: '知识产权',
        website: '网站管理',
        privacy: '隐私保护',
        especially: '特别声明',
        signUp: '注册登录',
        companyVip: '单位会员',
        personalVip: '个人会员',
        video: '如何视频',
      },
      tableData: [],//请求来的数组
      searchWord: '',//搜索关键字
      catalog: '',
    }
  },
  computed: {
    routecatalog() {
      return this.$route.query.catalog
    },
    routepage() {
      return this.$route.query.page
    },
  },
  watch: {
    //监听文章分类的改变
    routecatalog(val) {
      this.scrollHandle(640, '')
      // document.documentElement.scrollTop = 640//更换页码，回到距离顶部640的位置
      this.paging_data.currentPage = 1
      this.catalog = val

      let reqData = {}
      reqData.catalog = val
      val != 'news' && val != 'activity' ? '':reqData.pageNumber = 1//当分类不为列表展示的数据时，不加pagenumber属性
      reqData.areaId = this.pageAreaId_x
      this.getChenjNews(reqData)
    },
    routepage(val) {
      const CALLBACK = () => {
        this.paging_data.currentPage = parseInt(val)
        let reqData = {}
        reqData.catalog = this.catalog
        reqData.pageNumber = parseInt(val)
        reqData.areaId = this.pageAreaId_x
        this.getChenjNews(reqData)
      }
      this.scrollHandle(640, CALLBACK)
    }
  },
  methods: {
    scrollHandle(height, cb) {
      // 实现滚动效果
      let top = document.documentElement.scrollTop || document.body.scrollTop
      const timeTop = setInterval(() => {
        if (top - height < -100) {
          top += 100
        } else if (top - height > 100) {
          top -= 100
        } else {
          top = height
        }
        document.documentElement.scrollTop = top
        if (top === height) {
          clearInterval(timeTop)//先滚动，再发数据请求
          cb && cb()
        }
      }, 10)
    },
    //搜索框
    searchTitle() {
      console.log(this.searchWord)
    },
    //点击列表中的数据跳转
    jumpToDetail(catalog, id, outUrl) {
      if (outUrl =='' || outUrl == undefined) {
        let topTitle = ''
        catalog == 'news' ? topTitle = '新闻': topTitle = '活动'
        this.$router.push(`articleDetail?catalog=${catalog}&id=${id}&toptitle=${topTitle}`)
      } else {
        window.open(outUrl)
      }
    },
    get_page_number_article(pageNumber) {
      this.paging_data.currentPage = pageNumber
      this.$router.replace('articleList?catalog=news&areaNameStr=竞成&toptitle=竞成新闻&page='+pageNumber)
    },
  },
  created() {
    this.catalog = this.$route.query.catalog
    let reqData = {}
    reqData.catalog = this.$route.query.catalog
    reqData.pageNumber = parseInt(this.$route.query.page)
    reqData.areaId = this.pageAreaId_x
    this.getChenjNews(reqData)
  },
  mounted() {
    this.paging_data.pageSize = 40
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      console.log(document.documentElement.scrollTop)
      if (!['articleList', 'articleDetail', 'article'].includes(from.name)) {
        document.documentElement.scrollTop = 0
      } else {
        document.documentElement.scrollTop = 640
        // vm.scrollHandle(640, '')
        // let timer = setTimeout(() => {
        //   vm.scrollHandle(640, '')
        //   clearTimeout(timer)
        // }, 300)
      }
    })
  }
}
</script>

<style lang='scss' scoped>
.title{position: relative;height: 50px;line-height: 50px;padding: 0 15px;border: 1px solid #eeeeee;background-color: #f2f2f2;}
.title .shu{display: inline-block;border: 1.5px solid red;height: 18px;position: absolute;top: 15px;}
.title .name{display: inline-block;margin-left: 10px;}
.title .search{position: absolute;right: 0px;display: inline-block;padding: 0px;}
.title .search i{cursor: pointer;}

.newslist .item{align-items: flex-start;border-bottom: 1px solid #eee;height: 168px;padding: 20px;transition: all .2s;cursor: pointer;}
.newslist .item:hover{box-shadow: 0px 0px 20px #ccc;}
.newslist .item:hover .words>.p1{color: #1E9FFF;}
.newslist .item img{display: inline-block;height: 168px;width: 168px;border: 1px solid #000;}
.newslist .item .words{margin-left: 15px;flex: 1;}
.newslist .item .words .p1{font-size: 22px;margin-bottom: 10px;}
.newslist .item .words .p2{height: 66px;line-height: 33px;overflow: hidden;font-size: 14px;margin-bottom: 15px;color: #999;}
.newslist .item .words .p3{font-size: 14px;line-height: 22px;color: #999;}
.newslist .item .words .p3 span{display: inline-block;}
.newslist .item .words .p3 .view{margin-left: 100px;}
</style>